<style scoped="true" lang="scss">
    .blurry-image {
        transition: filter .35s ease-out;
        filter: grayscale(100%) blur(0);
        transform: translateZ(0);

        &--loading {
            filter: grayscale(100%) blur(20px);
            animation-duration: .35s;
            animation-name: blurry-image-fade-in;
        }

        @at-root {
            @keyframes blurry-image-fade-in {
                from {
                    opacity: 0;
                }

                to {
                    opacity: 1;
                }
            }
        }

    }
</style>

<template>
    <img :src="image" :class="classes" :alt="alt">
</template>

<script>
    export default {
        name: 'blurry-image',
        data() {
            return {
                loaded: false,
            }
        },
        props: {
            smallImage: '',
            largeImage: '',
            alt: ''
        },
        computed: {
            image() {
                if (this.loaded) {
                    return this.largeImage;
                }
                return this.smallImage;
            },
            classes() {
                const baseClass = `blurry-image`;
                if (this.loaded) {
                    return baseClass;
                }
                return `${baseClass} ${baseClass}--loading`;
            }
        },
        mounted() {
            const img = new Image();

            img.addEventListener('load', () => {
                this.loaded = true;
            });

            img.src = this.largeImage;
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// blurry-image.vue?68964583